module.exports = __webpack_public_path__ + "img/Paseos-imperdibles-en-Punta-del-Este-para-disfrutar-de-la-ciudad-a-pleno.eaf626fa.png";